<template>
  <div>
    <b-row align-h="between" align-v="center">
      <b-col cols="12" md="auto" >
        <h3 class="tabheading">{{$t('audits.summary')}}</h3>
        <h4 class="tabheading__subline text--right">{{$t('audits.title')}} {{ date }}</h4>
      </b-col>
    </b-row>
    <hr/>
    <b-row align-h="between">
      <b-col cols="12" lg="6" >
        <div class="contentcontainer">
          <div class="contentcontainer__head">
            <h4>{{$t('audits.modifiedfiles.title')}}</h4>
          </div>
          <hr/>
          <b-row>
            <b-col cols="12" md="2 ">
              <img v-if="audit && !audit.module_modifiedfiles_state" src="/images/icon/sitedetail/dashboard/corefile-danger.svg"/>
              <img v-else src="/images/icon/sitedetail/dashboard/corefile-success.svg"/>
            </b-col>
            <b-col cols="12" md="10">
              <p>
                {{$t('audits.modifiedfiles.description')}}
              </p>
            </b-col>
          </b-row>
        </div>
      </b-col>
      <b-col cols="12" lg="6" >
        <div class="contentcontainer">
          <div class="contentcontainer__head">
            <h4>{{$t('audits.suspiciousfiles.title')}}</h4>
          </div>
          <hr/>
          <b-row>
            <b-col cols="12" md="2">
                <img v-if="audit && !audit.module_suspiciousfiles_state" src="/images/icon/sitedetail/dashboard/suspfiles-danger.svg"/>
                <img v-else src="/images/icon/sitedetail/dashboard/suspfiles-success.svg"/>
            </b-col>
            <b-col cols="12" md="10">
              <p>
                {{$t('audits.suspiciousfiles.description')}}
              </p>
            </b-col>
          </b-row>
        </div>
      </b-col>
      <b-col cols="12" lg="6" v-if="audit && audit.module_joomlaconfiguration && audit.module_joomlaconfiguration.length">
        <div class="contentcontainer">
          <div class="contentcontainer__head">
            <h4>{{$t('audits.joomlaconfig.title')}}</h4>
          </div>
          <hr/>
          <b-row>
            <b-col cols="12" md="2">
              <img v-if="audit && !audit.module_joomlaconfiguration_state" src="/images/icon/sitedetail/dashboard/settings-danger.svg"/>
              <img v-else src="/images/icon/sitedetail/dashboard/settings-success.svg"/>
            </b-col>
            <b-col cols="12" md="10">
              <p>
                {{$t('audits.joomlaconfig.description')}}
              </p>
            </b-col>
          </b-row>
        </div>
      </b-col>
      <b-col cols="12" lg="6" v-if="audit && audit.module_users && typeof audit.module_users.weak_passwords !== 'undefined'">
        <div class="contentcontainer">
          <div class="contentcontainer__head">
            <h4>{{$t('audits.users.title')}}</h4>
          </div>
          <hr/>
          <b-row>
            <b-col cols="12" md="2">
              <img v-if="audit && !audit.module_users_state" src="/images/icon/sitedetail/dashboard/userdb-danger.svg"/>
              <img v-else src="/images/icon/sitedetail/dashboard/userdb-success.svg"/>
            </b-col>
            <b-col cols="12" md="10">
              <p>
                {{$t('audits.users.description')}}
              </p>
            </b-col>
          </b-row>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: 'AuditOverview',

  props: [
    'audit',
    'date'
  ]
}
</script>
